import React, { useEffect, useState, Suspense } from "react";
import "./App.css";
import "./loader.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Loading from "./components/Loading";
import StartPage from "./components/StartPage";
import Constants from "./Constants";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import NotFound from "./components/NotFound";
import BottomNav from "./components/BottomNav";

const Messages = React.lazy(() => import("./components/Messages"));
const Profile = React.lazy(() => import("./components/Profile"));
const Favorites = React.lazy(() => import("./components/Favorites"));
const VideoPage = React.lazy(() => import("./components/VideoPage"));
const VideoPageAF = React.lazy(() => import("./components/VideoPageAF"));
const AllTags = React.lazy(() => import("./components/AllTags"));
const ModelDirectory = React.lazy(() => import("./components/ModelDirectory"));
const TagSpecific = React.lazy(() => import("./components/TagSpecific"));
const NewsFlash = React.lazy(() => import("./components/NewsFlash"));
const WarningMsg = React.lazy(() => import("./components/WarningMsg"));
const SearchResults = React.lazy(() => import("./components/SearchResults"));
const ModelPage = React.lazy(() => import("./components/ModelPage"));
const NetworkSite = React.lazy(() => import("./components/NetworkSite"));
const AFSite = React.lazy(() => import("./components/AFSite"));
const TwoTwo = React.lazy(() => import("./components/TwoTwo"));
const PaidVideos = React.lazy(() => import("./components/PaidVideos"));

function App() {
  const [preferences, setPreferences] = useState({});
  const [popularTags, setPopularTags] = useState([]);
  const [unread, setUnread] = useState(0);
  const [csrf, setCSRF] = useState("");
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [warningMsg, setWarningMsg] = useState(false);
  useEffect(() => {
    let umamiTimer;
    const identifyUmami = (id) => {
      let tries = 0;
      const tag = () => {
        if (window.umami?.identify) {
          window.umami.identify({ id: String(id), site: "NVG" });
        } else if (tries++ < 20) {
          umamiTimer = setTimeout(tag, 250);
        }
      };
      clearTimeout(umamiTimer);
      tag();
    };
    const getCookie = (name) => {
      let cookie = {};
      document.cookie.split(";").forEach(function (el) {
        let [k, v] = el.split("=");
        cookie[k.trim()] = v;
      });
      return cookie[name];
    };
    const runInit = () => {
      fetch(`${Constants.API}init?cb=${Date.now()}`, {
        credentials: "include",
        cache: "no-store",
        headers: {
          "Cache-Control": "max-age=0, no-store",
        },
      })
        .then((res) => res.json())
        .then((res) => {
          if ("error" in res) {
            window.location.replace("https://vip.netvideogirls.com/login/");
            return;
          }
          if ("pref" in res && "av" in res.pref && res.pref.av === "Verify") {
            window.location.replace(
              "https://vip.netvideogirls.com/age-verification/",
            );
            return;
          }
          if ("pref" in res && "av" in res.pref && res.pref.av === "VPN") {
            window.location.replace(
              "https://vip.netvideogirls.com/utah-vpn-detection/",
            );
            return;
          }

          setCSRF(decodeURIComponent(getCookie("XSRF-TOKEN")));
          setPreferences({ favs: res.favs, pref: res.pref, ppv: res.ppv });
          setPopularTags(res.pop_tags);
          setNews(res.news);
          setUnread(res.unread);
          setLoading(false);
          if (res.pref.warning_msg === 1) {
            setWarningMsg(true);
          }

          if (res.pref.nats_id) identifyUmami(res.pref.nats_id);
        })
        .catch(() => {
          window.location.replace("https://vip.netvideogirls.com/login/");
          return;
        });
    };
    runInit();
    const handlePageShow = (event) => {
      if (event.persisted) {
        console.log("Page restored from bfcache. Re-running init.");
        runInit();
      }
    };
    window.addEventListener("pageshow", handlePageShow);
    return () => {
      window.removeEventListener("pageshow", handlePageShow);
      clearTimeout(umamiTimer);
    };
  }, []);

  if (loading) {
    return (
      <div className="loadingScreen">
        <Loading size="la-2x" extra=" m200" />
      </div>
    );
  }

  return (
    <div className="wrapper">
      <HelmetProvider>
        <Router>
          <Header
            tags={popularTags}
            avatar={preferences.pref.avatar}
            unread={unread}
            csrf={csrf}
            isAF={preferences.pref.username === "AFPass" ? true : false}
            display={
              preferences.pref.comment_name
                ? preferences.pref.comment_name
                : preferences.pref.username
            }
            addons={preferences.pref.addonsites}
          />
          <Suspense
            fallback={
              <div className="loadingScreen">
                <Loading size="la-2x" extra=" m200" />
              </div>
            }
          >
            <div className="mask" />
            <Switch>
              <Route path={`${Constants.HOME}messages/:personid?`} exact>
                <Messages setUnread={setUnread} />
              </Route>
              <Route
                path={`${Constants.HOME}tag/:tag_name/:tagid/:sort?/:page?/`}
                exact
              >
                <TagSpecific />
              </Route>
              <Route path={`${Constants.HOME}girl/:girl_name/:id`} exact>
                <ModelPage
                  preferences={preferences}
                  setPreferences={setPreferences}
                />
              </Route>
              <Route path={`${Constants.HOME}all-tags`} exact>
                <AllTags />
              </Route>
              <Route path={`${Constants.HOME}favorites`} exact>
                <Favorites />
              </Route>
              <Route path={`${Constants.HOME}paid-videos`} exact>
                <PaidVideos />
              </Route>
              <Route
                path={`${Constants.HOME}(casting-couch-hd|net-girl|net-video-girls)/:filter?/:year?/:page?`}
                exact
              >
                <NetworkSite />
              </Route>
              <Route path={`${Constants.HOME}add-friends/:page?`} exact>
                <AFSite />
              </Route>
              <Route path={`${Constants.HOME}2257`} exact>
                <TwoTwo />
              </Route>
              <Route path={`${Constants.HOME}not-found`} exact>
                <NotFound />
              </Route>
              <Route path={`${Constants.HOME}profile`} exact>
                <Profile
                  user={preferences.pref}
                  setPreferences={setPreferences}
                />
              </Route>
              <Route path={`${Constants.HOME}girls/:filter?/:year?/:page?`}>
                <ModelDirectory />
              </Route>
              <Route path={`${Constants.HOME}video/:id`}>
                <VideoPage
                  preferences={preferences}
                  ppv={preferences.ppv}
                  setPreferences={setPreferences}
                />
              </Route>
              <Route path={`${Constants.HOME}video-af/:id`}>
                <VideoPageAF
                  preferences={preferences}
                  ppv={preferences.ppv}
                  setPreferences={setPreferences}
                />
              </Route>
              <Route path={`${Constants.HOME}search-tags/:ids/:page?`}>
                <SearchResults csrf={csrf} />
              </Route>
              <Route path={`${Constants.HOME}:filter?/:year?/:page?`} exact>
                <StartPage news={news} />
              </Route>
            </Switch>
          </Suspense>
          <Footer />
          {/* <BottomNav /> */}
        </Router>
      </HelmetProvider>
      {warningMsg && (
        <Suspense fallback={null}>
          <WarningMsg setWarningMsg={setWarningMsg} />
        </Suspense>
      )}

      <Suspense fallback={null}>
        <NewsFlash news={news[0]} />
      </Suspense>
    </div>
  );
}

export default App;
